import { render } from "./PublicationDetails.vue.js?vue&type=template&id=851dfdb6!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationDetails.vue?vue&type=template&id=851dfdb6"
import script from "./PublicationDetails.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationDetails.vue?vue&type=script&lang=js"
export * from "./PublicationDetails.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/create-dashboard/views/PublicationDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "851dfdb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('851dfdb6', __exports__)) {
    api.reload('851dfdb6', __exports__)
  }
  
  module.hot.accept("./PublicationDetails.vue.js?vue&type=template&id=851dfdb6!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationDetails.vue?vue&type=template&id=851dfdb6", () => {
    api.rerender('851dfdb6', render)
  })

}


export default __exports__